/* global Swiper */

/*
 * Swiper for customer quotes in hero
 */
// Resources slider

(function () {

	"use strict";

	// init news and events carousel
	new Swiper(".resources .resources-slider-container", {
		slidesPerView: "auto",
		centeredSlides: false,
		spaceBetween: 30,
		navigation: {
			nextEl: ".q-carousel-button--next",
			prevEl: ".q-carousel-button--prev",
			disabledClass: "q-carousel-button--disabled"
		},
		pagination: {
			el: '.resources .swiper-pagination',
			type: 'arrows',
		},
	});

}());

/* global TimelineLite Waypoint */


// Lifecycle diagram entrance animation


(function () {
	var tl = new TimelineLite();
	var diagram = document.querySelector(".q-vmdr-workflow-picture");
	var ease = window.Power4.easeInOut;

	new Waypoint({
		element: diagram,
		offset: "100%",

		handler: function handler(direction) {
			if (direction === "down") {
				tl.fromTo(".workflow-picture", 0.75, { x: "-50px", autoAlpha: 0 }, { x: "0", autoAlpha: 1, ease: ease }, "start+=0.25");

				// trigger waypoint only once, destroy after it's first occurance
				this.destroy();
			}
		}
	});

	var tl1 = new TimelineLite();
	var whyPanel = document.querySelector(".q-grid__row--why");

	new Waypoint({
		element: whyPanel,
		offset: "100%",

		handler: function handler(direction) {
			if (direction === "down") {
				tl1.fromTo(".why-panel-1", 0.75, { y: "50px", autoAlpha: 0 }, { y: "0", autoAlpha: 1, ease: ease }, "start+=0.25");
				tl1.fromTo(".why-panel-2", 1.00, { y: "50px", autoAlpha: 0 }, { y: "0", autoAlpha: 1, ease: ease }, "start+=0.25");

				// trigger waypoint only once, destroy after it's first occurance
				this.destroy();
			}
		}
	});

	var tl2 = new TimelineLite();
	var whyIcons = document.querySelector(".q-grid__row--why-iocns");

	new Waypoint({
		element: whyIcons,
		offset: "100%",

		handler: function handler(direction) {
			if (direction === "down") {
				tl2.staggerFromTo(".why-iocns-item", 1.5, { y: "20%", autoAlpha: 0 }, { y: "0%", autoAlpha: 1, ease: ease }, 0.35, "-=0.75");

				this.destroy();
			}
		}
	});


	var pillars = Array.prototype.slice.call(document.querySelectorAll(".four-pillars"));

	pillars.forEach(function(self) {

		var tl3 = new TimelineLite();
		var imageLeft = self.querySelectorAll(".image-left");
		var imageRight = self.querySelectorAll(".image-right");
		var imageMobile = self.querySelectorAll(".pillar-graphics-mobile");

		new Waypoint({
			element: self,
			offset: "100%",
	
			handler: function handler(direction) {
				if (direction === "down") {
					tl3.fromTo(imageLeft, 0.75, { x: "-10%", autoAlpha: 0 }, { x: "0%", autoAlpha: 1, ease: ease }, 0.35, "-=0.15");
					tl3.fromTo(imageRight, 0.75, { x: "10%", autoAlpha: 0 }, { x: "0%", autoAlpha: 1, ease: ease }, 0.35, "-=0.15");
					tl3.fromTo(imageMobile, 0.75, { y: "10%", autoAlpha: 0 }, { y: "0%", autoAlpha: 1, ease: ease }, 0.35, "-=0.15");
	
					this.destroy();
				}
			}
		});


	});

}());

/* eslint-disable */
webpackJsonp([0],{

	/***/ 										26:
		/***/ (function(module, exports, __webpack_require__) {
	
			"use strict";
	
	
	
			var _Sticky = __webpack_require__(44);
	
			var _Sticky2 = _interopRequireDefault(_Sticky);
	
			function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
			var el = document.querySelectorAll(".q-subscriptions-sticky");
	
			Array.prototype.forEach.call(el, function(el, i){
				new _Sticky2.default(el); // eslint-disable-line
			});
	
			/***/ }),
	
		/***/ 										41:
		/***/ (function(module, exports) {
	
			// removed by extract-text-webpack-plugin
	
			/***/ }),
	
		/***/ 										44:
		/***/ (function(module, exports, __webpack_require__) {
	
			"use strict";
	
	
			Object.defineProperty(exports, "__esModule", {
				value: true
			});
	
			var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
			function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
			var Sticky = function () {
				function Sticky(el) {
					var _this = this;
					console.log(_this);
	
					_classCallCheck(this, Sticky);
	
					_initialiseProps.call(this);
	
					this.el = el || document.querySelector("." + this.blockName);
	
					this.stickyLayoutEl = this.el.querySelector("." + this.blockName + "__layout--sticky");
					this.listEl = this.el.querySelector("." + this.blockName + "__list");
					this.itemEls = this.el.querySelectorAll("." + this.blockName + "__item");
	
					this.build();
	
					setTimeout(function () {
						_this.onResize();
						_this.onScroll();
					});
	
					this.lastRender = 0;
	
					window.addEventListener("scroll", this.onScroll);
					window.addEventListener("resize", this.onResize);
				}
	
				_createClass(Sticky, [{
					key: "build",
					value: function build() {
						var _this2 = this;
	
						var glistEl = this.glistEl = document.createElement("div");
	
						this.itemEls.forEach(function (el) {
							var headlineEl = el.querySelector("." + _this2.blockName + "__heading");
							var itemEl = document.createElement("li");
	
							itemEl.className = _this2.blockName + "__gitem";
							itemEl.appendChild(headlineEl.cloneNode(true));
							glistEl.appendChild(itemEl);
						});
	
						glistEl.className = this.blockName + "__glist";
						this.gitemEls = glistEl.childNodes;
	
						this.el.appendChild(glistEl);
					}
				}, {
					key: "handleLayout",
					value: function handleLayout(scrollY) {
						var offset = this.offsetTop + this.height - window.innerHeight;
	
						if (scrollY > offset) {
							this.stickyLayoutEl.style.position = "absolute";
						}
					}
				}, {
					key: "handleHeadlines",
					value: function handleHeadlines(scrollY) {
						var _this3 = this;
	
						if (scrollY >= this.itemsOffsetTop + this.offsetTop - window.innerHeight + this.items.length * this.headlineHeight) {
							this.glistEl.style.position = "fixed";
							this.glistEl.style.top = "";
							this.glistEl.style.bottom = "0px";
						} else {
							this.glistEl.style.position = "absolute";
							this.glistEl.style.top = this.itemsOffsetTop + "px";
							this.glistEl.style.bottom = "";
						}
	
						var hiddenClassName = this.blockName + "__gitem--hidden";
	
						this.items.forEach(function (item, i) {
							var invertedIndex = _this3.items.length - i;
							var offset = item.offsetTop + _this3.offsetTop - window.innerHeight + invertedIndex * _this3.headlineHeight;
	
							if (scrollY >= offset) {
								if (!item.ghostEl.classList.contains(hiddenClassName)) {
									item.ghostEl.classList.toggle(hiddenClassName, true);
								}
							} else {
								if (item.ghostEl.classList.contains(hiddenClassName)) {
									item.ghostEl.classList.toggle(hiddenClassName, false);
								}
							}
						});
					}
				}]);
	
				return Sticky;
			}();
	
			var _initialiseProps = function _initialiseProps() {
				var _this4 = this;
	
				this.items = [];
				this.blockName = "q-subscriptions-sticky";
	
				this.onScroll = function () {
					var scrollY = window.scrollY || document.querySelector("html").scrollTop;
	
					if (Date.now() - _this4.lastRender > 5000) {
						_this4.onResize();
					}
	
					_this4.handleLayout(scrollY);
					_this4.handleHeadlines(scrollY);
				};
	
				this.onResize = function () {
					_this4.offsetTop = _this4.el.offsetTop;
					_this4.height = _this4.el.offsetHeight;
	
					_this4.headlineHeight = _this4.gitemEls[0].offsetHeight;
					_this4.itemsOffsetTop = _this4.listEl.offsetTop;
	
					_this4.glistEl.style.left = _this4.itemEls[0].offsetLeft + "px";
					_this4.glistEl.style.width = _this4.itemEls[0].offsetWidth + "px";
	
					_this4.itemEls.forEach(function (el, i) {
						_this4.items[i] = {
							el: el,
							ghostEl: _this4.gitemEls[i],
							offsetTop: el.offsetTop
						};
					});
	
					_this4.lastRender = Date.now();
				};
			};
	
			exports.default = Sticky;
	
			/***/ }),
	
		/***/ 										80:
		/***/ (function(module, exports, __webpack_require__) {
	
			__webpack_require__(26);
			module.exports = __webpack_require__(41);
	
	
			/***/ })
	
	},[80]);
	/* eslint-enable */